import { Box } from "@mui/material";
import { useHasValidFeatureProjectLevel } from "@hooks/feature-control/use-has-user-valid-feature-project-level";
import { ExportWorkspaceOrProjects } from "@pages/settings/export-workspace/export-workspace-or-project";
import { useAppSelector } from "@store/store-helper";
import { selectedProjectSelector } from "@store/projects/projects-selector";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";

/**
 * Component to show the section to export the project data in project settings page.
 * The visibility of this section is based on the project features and company level permissions.
 * If the user doesn't have the required permissions or features, this component will return null and won't be rendered in the UI.
 */
export function ExportProjectData(): JSX.Element | null {
  const { canExportProject } = useHasValidFeatureProjectLevel();
  const selectedProject = useAppSelector(selectedProjectSelector);
  // To export a project, you also need to have the permission to export the workspace data on the company level
  const { canExportWorkspace } = useHasUserValidRoleCompanyLevel();

  if (!canExportProject || !canExportWorkspace || !selectedProject) {
    return null;
  }

  return (
    <Box
      component="div"
      mt="40px"
    >
      <ExportWorkspaceOrProjects
        entityName="project"
        projectIds={[selectedProject.id]}
      />
    </Box>
  );
}
